import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SignupService } from '../../../services/signup.service';
import { ToastrService } from 'ngx-toastr';
import { WatcherService } from 'src/app/services/watcher.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { Router } from '@angular/router';
import { error } from 'console';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { b2bShipment } from '../b2b-create-shipment/b2b-create-shipment.component';
import { B2BShipmentsDataSource } from 'src/app/services/b2bshipments.service';
import { MatDialog } from '@angular/material/dialog';
import { ShipmentContentDetailDialog } from './shipment-content-detail-dialog/shipment-content-detail-dialog';
import { allCountriesList } from 'src/app/shared/countryList';
import { PrintInVoiceAndLabelDialog } from './print-invoice-label-dialog/print-invoice-label-dialog';
import { B2BArrangePickupDialog } from 'src/app/features/B2B/b2b-arrange-pickup-dialog/b2b-arrange-pickup-dialog';
import { B2BArrangePickupDetailsDialog } from 'src/app/features/B2B/b2b-pickup-details-dialog/b2b-pickup-details-dialog';

declare var $;
declare var Stripe: any;
@Component({
  selector: 'app-b2b-shipments-list',
  templateUrl: './b2b-shipments-list.component.html',
  styleUrls: ['./b2b-shipments-list.component.css'],
})
export class B2BShipmentListComponent implements OnInit, AfterViewInit {
  token;
  userID;
  lang;
  memberDetails;
  dataSource: MatTableDataSource<any>;
  countriesList: any[] = allCountriesList;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public signUpService: SignupService,
    private toastr: ToastrService,
    private watcherService: WatcherService,
    private store: Store<AppState>,
    private router: Router,
    private _liveAnnouncer: LiveAnnouncer,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.signUpService.getAllCountries().subscribe((list) => {
      this.countriesList = list['data'];
    });
    this.store.select('auth').subscribe((state) => {
      this.token = state.token;
      this.userID = state.user?.id;
    });
    this.signUpService
      .getUserByUserID(this.userID, this.token)
      .subscribe((data) => {
        this.memberDetails = data['data'];
      });
  }

  shipmentsResponseData;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  ngOnInit(): void {
    window.scrollTo(0, 0);
    // this.dataSource.sort = this.sort;

    if (this.userID && this.token) {
      this.signUpService
        .listB2BShipmentsViaUserID(this.token, this.userID)
        .subscribe({
          next: (data) => {
            let tempData = data['data'].filter(
              (element) =>
                element.status >= 7 ||
                element.status == 0 ||
                element.status == 98
            );
            tempData.forEach((element) => {
              try {
                element.shipment.company_name = this.getCourierName(
                  element.shipment.company_id
                );
                element.shipment.service_type_name = this.getServiceTypeName(
                  element.shipment.service_type
                );
                element.status_name = this.getShipmentStatusName(
                  element.status
                );
                element.destination_counyry_name = this.getCountryName(
                  element.shipment.zone
                );
              } catch (error) {
                this.toastr.error(
                  'An error occured while building table',
                  'Error'
                );
              }
            });
            this.shipmentsResponseData = tempData;
            this.dataSource = new MatTableDataSource(tempData);
            this.dataSource.sort = this.sort;
            // this.dataSource.paginator = this.paginator;
            this.dataSource.sortingDataAccessor = (item, property) => {
              switch (property) {
                case 'CreatedDate':
                  return item.created_date;
                case 'ShipmentNumber':
                  return item.shipment_number;
                case 'TotalPaid':
                  return item.charge.paid.amount;
                case 'Status':
                  return item.status;
                case 'Carrier':
                  return item.shipment.company_name;
                default:
                  return item['created_date'];
              }
            };
            this.cdr.markForCheck();
            this.cdr.detectChanges();
          },
          error: (error) => {
            this.toastr.error(error.error.message);
          },
        });
    }

    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });
  }
  ngAfterViewInit(): void {
    // this.dataSource.sort = this.sort;
  }
  getCourierName(company_id) {
    const courier = this.courierList.find(
      (element) => element.id == company_id
    );
    return courier ? courier.name : 'N/A';
  }

  getServiceTypeName(serviceType) {
    const service = this.serviceTypeList.find(
      (element) => element.id == serviceType
    );
    return service ? service.name : 'N/A';
  }

  getShipmentStatusName(status) {
    const shipmentStatus = this.b2bShipmentStatusList.find(
      (element) => element.id == status
    );
    return shipmentStatus ? shipmentStatus.name : 'N/A';
  }

  getCountryName(country_code) {
    if (country_code) {
      const country = this.countriesList.find(
        (element) => element.code == country_code
      );
      return country ? country.name : 'N/A';
    } else {
      return 'N/A';
    }
  }

  serviceTypeList = [
    { name: 'Express', id: 1 },
    { name: 'Economy', id: 2 },
    { name: 'Connect Plus', id: 3 },
    { name: 'Standard', id: 4 },
    { name: 'Regional Economy', id: 5 },
  ];
  courierList = [
    { name: 'TNT', id: 1 },
    { name: 'UPS', id: 2 },
    { name: 'DHL', id: 3 },
    { name: 'FedEx', id: 4 },
    { name: 'AusPost', id: 5 },
    { name: 'USPS', id: 6 },
    { name: 'Aramex', id: 7 },
    { name: 'LaPoste', id: 8 },
    { name: 'TNT', id: 9 },
    { name: 'TNT', id: 10 },
    { name: 'MNG', id: 11 },
    { name: 'EMS', id: 12 },
    { name: 'DPD', id: 13 },
    { name: 'Evri', id: 14 },
  ];
  b2bShipmentStatusList = [
    { name: 'Canceled', id: 0 },
    { name: 'Waiting Payment', id: 6 },
    { name: 'Ready To Shipment', id: 7 },
    { name: 'In Transit', id: 8 },
    { name: 'Shipped', id: 8 },
    { name: 'Delivered', id: 9 },
    { name: 'Label Failed', id: 98 },
  ];

  displayedColumns = [
    'CreatedDate',
    'ShipmentNumber',
    'Carrier',
    'Service',
    'Destination',
    'Recipient',
    'Status',
    'PickUp',
    'TotalPaid',
    'Tracking',
    'Actions',
  ];
  printLabel(label) {
    window.open(label, '_blank');
  }
  sortShipmentBy;
  searchB2BNumber;
  sortingType = 'sortByDate';
  announceSortChange(sortState: Sort) {
    this.sortData(sortState);
  }

  sortData(sort: Sort): void {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      // Implement sorting logic based on the column
      return this.compare(a[sort.active], b[sort.active], isAsc);
    });
  }

  // Helper function for comparing values
  compare(a: any, b: any, isAsc: boolean): number {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortShipments(event: Sort) {}

  openShipmentDetailDialog(shipment): void {
    this.dialog.open(ShipmentContentDetailDialog, {
      disableClose: true,
    });
  }

  openPrintLabelAndInvoiceDialog(shipment) {
    this.dialog.open(PrintInVoiceAndLabelDialog, { data: shipment });
  }

  openArrangePickupDialog(shipment) {
    const senderAddresses = this.memberDetails.addresses;
    const dialogRef = this.dialog.open(B2BArrangePickupDialog, {
      data: { shipment: shipment, addresses: senderAddresses },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result != null) {
        try {
          result.shipment.company_name = this.getCourierName(
            result.shipment.company_id
          );

          result.shipment.service_type_name = this.getServiceTypeName(
            result.shipment.service_type
          );

          result.status_name = this.getShipmentStatusName(result.status);

          result.destination_counyry_name = this.getCountryName(
            result.shipment.zone
          );
        } catch (error) {
          this.toastr.error(
            'An error occured while updating shipment!',
            'Error'
          );
        }

        this.shipmentsResponseData = this.shipmentsResponseData.map((el) => {
          if (el.shipment_number == result.shipment_number) {
            return result;
          }
          return el;
        });

        console.table(this.shipmentsResponseData);

        this.dataSource = new MatTableDataSource([
          ...this.shipmentsResponseData,
        ]);
        this.dataSource.sort = this.sort;
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      }
    });
  }

  openArrangePickupDetailDialog(shipment) {
    const senderAddresses = this.memberDetails.addresses;
    this.dialog.open(B2BArrangePickupDetailsDialog, {
      data: { shipment: shipment, addresses: senderAddresses },
    });

    
  }
}
